var map = {
	"./AdGuardDnsInfo.vue": [
		67727,
		[
			7727
		]
	],
	"./AdGuardFilterStatus.vue": [
		45557,
		[
			5557
		]
	],
	"./AdGuardStats.vue": [
		32425,
		[
			7461,
			4806
		]
	],
	"./AdGuardTopDomains.vue": [
		53364,
		[
			3364
		]
	],
	"./AnonAddy.vue": [
		62939,
		[
			2939
		]
	],
	"./Apod.vue": [
		24437,
		[
			4437
		]
	],
	"./BlacklistCheck.vue": [
		65286,
		[
			5286
		]
	],
	"./Blank.vue": [
		41695,
		[
			1695
		]
	],
	"./ChuckNorris.vue": [
		67737,
		[
			7737
		]
	],
	"./Clock.vue": [
		56410,
		[
			6410
		]
	],
	"./CodeStats.vue": [
		63927,
		[
			7461,
			3927
		]
	],
	"./CovidStats.vue": [
		42258,
		[
			7461,
			2258
		]
	],
	"./CryptoPriceChart.vue": [
		2901,
		[
			7461,
			2901
		]
	],
	"./CryptoWatchList.vue": [
		47010,
		[
			7010
		]
	],
	"./CustomList.vue": [
		49642,
		[
			9642
		]
	],
	"./CustomSearch.vue": [
		26613,
		[
			6613
		]
	],
	"./CveVulnerabilities.vue": [
		22425,
		[
			2425
		]
	],
	"./DomainMonitor.vue": [
		44724,
		[
			4724
		]
	],
	"./DroneCi.vue": [
		36125,
		[
			6125
		]
	],
	"./EmbedWidget.vue": [
		20355,
		[
			355
		]
	],
	"./EthGasPrices.vue": [
		90947,
		[
			7461,
			947
		]
	],
	"./ExchangeRates.vue": [
		48091,
		[
			8091
		]
	],
	"./Filebrowser.vue": [
		88201,
		[
			8612,
			8201
		]
	],
	"./Flights.vue": [
		52016,
		[
			2016
		]
	],
	"./GitHubProfile.vue": [
		94807,
		[
			4807
		]
	],
	"./GitHubTrending.vue": [
		33031,
		[
			3031
		]
	],
	"./GlAlerts.vue": [
		52394,
		[
			2394
		]
	],
	"./GlCompactMetrics.vue": [
		57686,
		[
			7686
		]
	],
	"./GlCpuCores.vue": [
		74835,
		[
			4835
		]
	],
	"./GlCpuGauge.vue": [
		99847,
		[
			9847
		]
	],
	"./GlCpuHistory.vue": [
		2109,
		[
			7461,
			2109
		]
	],
	"./GlCpuSpeedometer.vue": [
		86218,
		[
			6218
		]
	],
	"./GlCpuTemp.vue": [
		77200,
		[
			7200
		]
	],
	"./GlDiskIo.vue": [
		1316,
		[
			1316
		]
	],
	"./GlDiskSpace.vue": [
		69399,
		[
			9399
		]
	],
	"./GlIpAddress.vue": [
		92655,
		[
			2655
		]
	],
	"./GlLoadHistory.vue": [
		15217,
		[
			7461,
			5217
		]
	],
	"./GlMemGauge.vue": [
		56058,
		[
			6058
		]
	],
	"./GlMemHistory.vue": [
		82081,
		[
			7461,
			2081
		]
	],
	"./GlMemSpeedometer.vue": [
		8991,
		[
			8991
		]
	],
	"./GlNetworkInterfaces.vue": [
		23473,
		[
			3473
		]
	],
	"./GlNetworkTraffic.vue": [
		9364,
		[
			7461,
			9364
		]
	],
	"./GlSystemLoad.vue": [
		54799,
		[
			7461,
			4799
		]
	],
	"./GlancesUptime.vue": [
		9004,
		[
			9004
		]
	],
	"./GluetunStatus.vue": [
		92075,
		[
			2075
		]
	],
	"./HackernewsTrending.vue": [
		1605,
		[
			1605
		]
	],
	"./HealthChecks.vue": [
		45433,
		[
			5433
		]
	],
	"./IframeWidget.vue": [
		2816,
		[
			2816
		]
	],
	"./ImageWidget.vue": [
		43839,
		[
			3839
		]
	],
	"./Jokes.vue": [
		12626,
		[
			2626
		]
	],
	"./Linkding.vue": [
		5375,
		[
			5375
		]
	],
	"./MinecraftStatus.vue": [
		98896,
		[
			8896
		]
	],
	"./MullvadStatus.vue": [
		57762,
		[
			7762
		]
	],
	"./Mvg.vue": [
		98298,
		[
			8298
		]
	],
	"./MvgConnection.vue": [
		91124,
		[
			1124
		]
	],
	"./NdCpuHistory.vue": [
		44976,
		[
			7461,
			4976
		]
	],
	"./NdLoadHistory.vue": [
		16648,
		[
			7461,
			6648
		]
	],
	"./NdRamHistory.vue": [
		93762,
		[
			7461,
			3762
		]
	],
	"./NewsHeadlines.vue": [
		2959,
		[
			2959
		]
	],
	"./NextcloudNotifications.vue": [
		4833,
		[
			4833
		]
	],
	"./NextcloudPhpOpcache.vue": [
		56677,
		[
			6677
		]
	],
	"./NextcloudStats.vue": [
		97358,
		[
			7358
		]
	],
	"./NextcloudSystem.vue": [
		32254,
		[
			7461,
			2254
		]
	],
	"./NextcloudUser.vue": [
		45289,
		[
			5289
		]
	],
	"./NextcloudUserStatus.vue": [
		44896,
		[
			4896
		]
	],
	"./PiHoleStats.vue": [
		41604,
		[
			7461,
			1604
		]
	],
	"./PiHoleStatsV6.vue": [
		45831,
		[
			7461,
			5831
		]
	],
	"./PiHoleTopQueries.vue": [
		99384,
		[
			9384
		]
	],
	"./PiHoleTopQueriesV6.vue": [
		32761,
		[
			2761
		]
	],
	"./PiHoleTraffic.vue": [
		31522,
		[
			7461,
			1522
		]
	],
	"./PiHoleTrafficV6.vue": [
		425,
		[
			7461,
			425
		]
	],
	"./Proxmox.vue": [
		49934,
		[
			9934
		]
	],
	"./PublicHolidays.vue": [
		5591,
		[
			5591
		]
	],
	"./PublicIp.vue": [
		81270,
		[
			1270
		]
	],
	"./RescueTime.vue": [
		83882,
		[
			3882
		]
	],
	"./RssFeed.vue": [
		76830,
		[
			6830
		]
	],
	"./Sabnzbd.vue": [
		42233,
		[
			2233
		]
	],
	"./SportsScores.vue": [
		58899,
		[
			8899
		]
	],
	"./StatPing.vue": [
		19173,
		[
			9173
		]
	],
	"./StockPriceChart.vue": [
		67396,
		[
			7461,
			7396
		]
	],
	"./SynologyDownload.vue": [
		94311,
		[
			4311
		]
	],
	"./SystemInfo.vue": [
		52645,
		[
			7461,
			2645
		]
	],
	"./TacticalRMM.vue": [
		42086,
		[
			2086
		]
	],
	"./TflStatus.vue": [
		75808,
		[
			5808
		]
	],
	"./UptimeKuma.vue": [
		13626,
		[
			8612,
			3626
		]
	],
	"./UptimeKumaStatusPage.vue": [
		92234,
		[
			2234
		]
	],
	"./WalletBalance.vue": [
		3702,
		[
			3702
		]
	],
	"./Weather.vue": [
		68443,
		[
			8443
		]
	],
	"./WeatherForecast.vue": [
		51668,
		[
			1668
		]
	],
	"./WidgetBase.vue": [
		2048,
		[]
	],
	"./XkcdComic.vue": [
		15836,
		[
			5836
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42625;
module.exports = webpackAsyncContext;